module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rateassist-distances-tab-content"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('blockquote', [_vm._v("\n        Add a distance band\n        "), _c('div', {
    staticClass: "btn btn-primary sq pull-right",
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("\n          Add\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "bp-type"
    }
  }, [_vm._v("Distance Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.distanceType),
      expression: "distanceType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bp-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.distanceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.distances), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)])]), _vm._v(" "), _vm._l((_vm.distanceEntries), function(dis, i) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "shadow clearfix"
    }, [_c('hr', {
      staticClass: "hr-text",
      attrs: {
        "data-content": ("BAND " + (i + 1))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": 'dis-min-' + i
      }
    }, [_vm._v("Minmimum")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (dis.minimumValue),
        expression: "dis.minimumValue"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "0.01",
        "id": 'dis-min-' + i
      },
      domProps: {
        "value": (dis.minimumValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(dis, "minimumValue", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": 'dis-max-' + i
      }
    }, [_vm._v("Maximum")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (dis.maximumValue),
        expression: "dis.maximumValue"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "0.01",
        "id": 'dis-max-' + i
      },
      domProps: {
        "value": (dis.maximumValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(dis, "maximumValue", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('hr'), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.remove(i)
        }
      }
    }, [_vm._v("\n                Delete\n              ")])])])])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ea01354"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/rateassist/components/Distances.vue
// module id = 2090
// module chunks = 1